export default function ParkSubInfo({title, children}) {
    return(
        <div className={`text-center`}>
            <h4 className={`uppercase text-sm font-brandon font-black pb-1 text-brown-300`}>{title}</h4>
            {children ?
                <p className={`text-sm`}>{children}</p>
                : null}
        </div>
    )
}